import { IPriseJobsPreview } from 'pages/common/IPriseJobs';
import Candidates from 'pages/iPriseV2/business-head/candidates';
import JobQueue from 'pages/iPriseV2/business-head/job-queue';
import Header from 'pages/iPriseV2/business-head/layout/Header';
import MyTeam from 'pages/iPriseV2/business-head/my-team';
import BusinessHeadProfile from 'pages/iPriseV2/business-head/profile';
import Reports from 'pages/iPriseV2/business-head/reports';
import CandidateMatchScoresScreen from 'pages/iPriseV2/common/candidate-match-scores';
import Teams from 'pages/iPriseV2/common/teams';
import TeamDetail from 'pages/iPriseV2/common/teams/team-detail';
import ViewCandidate from 'pages/iPriseV2/common/view-candidate';
import ViewJobV2 from 'pages/iPriseV2/common/view-job';
import ViewMatchedCandidate from 'pages/iPriseV2/common/view-matched-candidate';
import { ViewJob } from 'pages/sales/JobPosting/ViewJob';
import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

const BusinessHeadRoutes = () => {
  return (
    <Routes>
      <Route path="business-head" element={<Header />}>
        <Route index element={<Navigate to="job-queue" replace />} />
        <Route path="job-queue" element={<JobQueue />} />
        <Route path="view-job/:id" element={<ViewJobV2 />} />
        <Route
          path={'job-post/view-job/iprise-job/:jobId'}
          element={<ViewJob />}
        />
        <Route
          path={'job-post/view-job/iprise-job/candidate/:jobId/:candidateId'}
          element={<IPriseJobsPreview visible={true} />}
        />
        <Route
          path="view-matched-candidate"
          element={<ViewMatchedCandidate />}
        />
        <Route
          path="view-matched-candidate-scores"
          element={<CandidateMatchScoresScreen />}
        />
        <Route path="view-candidate/:candidateId" element={<ViewCandidate />} />
        <Route path="candidates" element={<Candidates />} />
        <Route path="teams" element={<Teams />} />
        <Route path="team/:id" element={<TeamDetail />} />
        <Route path="my-team" element={<MyTeam />} />
        <Route path="reports" element={<Reports />} />
        <Route path="profile" element={<BusinessHeadProfile />} />
      </Route>
      {/* Redirect any unknown route to business-head/job-queue */}
      <Route
        path="*"
        element={<Navigate to="business-head/job-queue" replace />}
      />
    </Routes>
  );
};

export default BusinessHeadRoutes;
